<template>
  <div>
    <a-card>
      <g-master name="Dependientes"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                modalWidth="80%"
                ref="master">
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Año de Vigencia')">
                <a-input-number style="width: 100%"
                  v-decorator="['year', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Nombre')">
                <a-input
                  class="ant-uppercase"
                  v-decorator="['person_name', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de Documento')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_document_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="tipo_documento">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Numero de Documento')">
                <a-input
                  class="ant-uppercase"
                  v-decorator="['document_number', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Parentesco')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_relationship', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="id_h_relationship">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha de Nacimiento')">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['date_birth', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-card>
  </div>
</template>

<script>
  export default {
    name: 'EmployeeRetefteDedupendiente',
    props: ['id_emp'],
    data () {
      return {
        id_h_relationship: {
          h_lookup_type: 'PARENTESCO'
        },
        tipo_documento: {
          h_lookup_type: 'TIPO_DOCUMENTO'
        },
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'emp_retefte_dependent',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            selectedRows: [],
            columns: [
              {title: this.$t('Año de Vigencia'), dataIndex: 'year', sorter: true},
              {title: 'Nombre', dataIndex: 'person_name', sorter: true},
              {title: 'Tipo de Documento', dataIndex: 'h_document_type', sorter: true},
              {title: 'Numero de Documento', dataIndex: 'document_number', sorter: true},
              {title: 'Parentesco', dataIndex: 'h_relationship', sorter: true},
              {title: 'Fecha Nacimiento', dataIndex: 'desc_date_birth', sorter: true},
              {title: 'Edad', dataIndex: 'edad', sorter: true}
            ]
          },
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeRetefteDeduPendiente.vue